import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type CameraIconProps = {
  size?: number
  color?: string
  className?: string
}

export const CameraIcon = ({
  size = 12,
  color = tokenVar('colors.icon.secondary'),
  className,
}: CameraIconProps) => (
  <svg
    aria-label='Camera'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 18 12'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17 2.42857L11.9091 6L17 9.57143V2.42857Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
    <path
      d='M10.4545 1H2.45455C1.65122 1 1 1.63959 1 2.42857V9.57143C1 10.3604 1.65122 11 2.45455 11H10.4545C11.2579 11 11.9091 10.3604 11.9091 9.57143V2.42857C11.9091 1.63959 11.2579 1 10.4545 1Z'
      stroke={color}
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='2'
    />
  </svg>
)
